<div class="header-container" *ngIf="isInitialized" [ngSwitch]="rootRoute">
  <!-- Transparent Header (For Home Only) -->
  <header class="main-header home" *ngSwitchCase="'/'">
    <ul class="left-group">
      <img src="assets/images/sgs_airsense.png" style="height: 56px; cursor: pointer" (click)="goHome()">
    </ul>

    <ul class="right-group" *ngIf="!(isLoggedIn$ | async)">
      <li class="sign-in" (click)="logIn()">
        Log In
      </li>
      <li class="sign-up" (click)="signUp()">
        Sign Up
      </li>
    </ul>
    <ul class="right-group" *ngIf="(isLoggedIn$ | async)">
      <li class="sign-in" (click)="logOut()">
        Log Out
      </li>
    </ul>
  </header>
  <!-- /.Transparent Header (For Home Only) -->

  <!-- Black Header (Default Header) -->
  <header class="main-header" *ngSwitchDefault>
    <ul class="left-group">
      <img src="assets/images/sgs_airsense.png" class="logo" style="height: 56px; cursor: pointer;"
           (click)="goHome()">
    </ul>

    <ul class="center-group" *ngIf="rootRoute === '/dashboard' || rootRoute === '/report'">
      <li class="main-nav" [routerLink]="['/dashboard']" routerLinkActive="main-menu--active">
        DASHBOARD
      </li>
      <li class="main-nav"
          style="margin-left: 48px;"
          *ngIf="(selfOrganizationUser$ | async) && (selfOrganizationUser$ | async)?.role !== OrganizationUserRole.Member"
          [routerLink]="['/report']"
          routerLinkActive="main-menu--active">
        WEEKLY REPORT
      </li>
    </ul>

    <ul class="right-group" *ngIf="rootRoute === '/dashboard' || rootRoute === '/report'">
      <ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
        <!-- Dropdown Menu -->
        <li class="user-settings" style="margin-left: 16px" (document:click)="onDropdownEvent($event, userSettings)"
            #userSettings>
          {{(user$ | async)?.email}}
          <object type="image/svg+xml" style="padding-left: 4px; padding-bottom: 2px; width: 9px; height: 6px;"
                  data="assets/images/header/ic_caret_down.svg">Your browser does not support SVGs
          </object>
          <ul class="dropdown">
            <li class="list-header">
              <div class="main">{{(user$ | async)?.email}}</div>
              <div class="sub">
                {{(selfOrganizationUser$ | async)?.role | namize}}
                <img src="assets/images/header/key.png"
                     *ngIf="(selfOrganizationUser$ | async)?.role !== OrganizationUserRole.Member"
                     style="width: 16px; height: 16px; cursor: pointer; margin-left: 4px;"
                     (click)="copyDevToken(selectedOrganization.token)">
              </div>
            </li>
            <li class="divider" style="padding-top: 8px;"></li>
            <!-- Account Settings -->
            <li class="list-item__header">
              Account Settings
            </li>
            <li class="list-item" (click)="openOrgList()">
              Organizations
            </li>
            <ng-container *ngIf="(selfOrganizationUser$ | async) as selfOrganizationUser">
              <li class="list-item" (click)="openP13n(selectedOrganization.token, selfOrganizationUser.tempUnit)">
                Personalization
              </li>
            </ng-container>
            <!-- /.Account Settings -->
            <li class="divider"></li>
            <!-- Organization Settings -->
            <div *ngIf="(selfOrganizationUser$ | async)?.role !== OrganizationUserRole.Member">
              <li class="list-item__header">
                Organization Settings
              </li>
              <li class="list-item"
                  *ngIf="(selfOrganizationUser$ | async)?.role === OrganizationUserRole.Owner"
                  (click)="openAccessMgmt(selectedOrganization.token)">
                Access Management
              </li>
              <!-- ID is added to device settings for appcues tooltip to locate element -->
              <li class="list-item"
                  id="device-settings"
                  *ngIf="(selfOrganizationUser$ | async)?.role !== OrganizationUserRole.Member"
                  (click)="openDeviceSettings()">
                Device Settings
              </li>
              <li class="list-item" (click)="openGroups()">
                Groups
              </li>
              <li class="divider"></li>
            </div>
            <!-- /.Organization Settings -->

            <!-- Log Out -->
            <li class="list-item" style="color: #E63740" (click)="logOut()">
              Log Out
            </li>
            <!-- Log Out -->
          </ul>
        </li>
        <!-- /.Dropdown Menu -->
      </ng-container>
    </ul>
  </header>
  <!-- /.Black Header (Default Header) -->
</div>
